// Shared by Onboarding and the tabs it hosts.
export const CONSIGNMENT_ONBOARDING_TAB = {
	RegistrationAccess: "registration-access",
	Registration: "registration",
	Curation: "curation",
	Contract: "contract",
} as const;

export type ConsignmentOnboardingTab =
	(typeof CONSIGNMENT_ONBOARDING_TAB)[keyof typeof CONSIGNMENT_ONBOARDING_TAB];
